import { createSelector } from 'reselect';

const selectCrmtasks = (state: any) => state.crmtasks;


export const selectCrmtasksCurrentItem = createSelector([selectCrmtasks], (crmtasks) => crmtasks.current);

export const selectCrmtasksListItems = createSelector([selectCrmtasks], (crmtasks) => crmtasks.list);

export const selectCrmtasksItemById = (itemId: any) =>
    createSelector(selectCrmtasksListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectCrmtasksQueryItems = createSelector([selectCrmtasks], (crmtasks) => crmtasks.query);

export const selectCrmtasksCreatedItem = createSelector([selectCrmtasks], (crmtasks) => crmtasks.create);

export const selectCrmtasksUpdatedItem = createSelector([selectCrmtasks], (crmtasks) => crmtasks.update);

export const selectCrmtasksReadItem = createSelector([selectCrmtasks], (crmtasks) => crmtasks.read);

export const selectCrmtasksDeletedItem = createSelector([selectCrmtasks], (crmtasks) => crmtasks.delete);

export const selectCrmtasksSearchedItems = createSelector([selectCrmtasks], (crmtasks) => crmtasks.search);

export const selectCrmtasksItemsCount = createSelector([selectCrmtasks], (crmtasks) => crmtasks.count);

export const selectCrmtasksItemsFilter = createSelector([selectCrmtasks], (crmtasks) => crmtasks.filter);